module.exports = __webpack_public_path__ + "static/media/brand.81fd66e9.png";